<template>
  <div class="wall_style_swiper">
    <swiper ref="swiper" :options="swiperOption" class="swiper">
      <swiper-slide v-for="(item, index) in postList" :key="index">
        <div>
          <div v-if="isFileExtVideo(item.ext)">
            <!-- <el-image
              :src="defaultSrc"
              fit="fit" 
              style="width: 144px; height: 144px"
              @click="handleDetails(item)"
            ></el-image> -->
            <video-player
              class="video_c vjs-custom-skin v"
              ref="videoPlayer"
              :playsinline="true"
              :options="playerOptionsList[item.id]"
            ></video-player>
          </div>
          <div v-else>
            <el-image
              :src="item.savepath"
              fit="fit"
              style="width: 100%; height: 144px"
              :preview-src-list="srcList"
            ></el-image>
          </div>

          <div class="my_flex" style="font-size: 14px">
            <div>{{ item.truename }}</div>
            <div>赞（{{ item.like_count }}）</div>
          </div>
        </div>
      </swiper-slide>

      <div class="swiper-button-prev" slot="button-prev"></div>
      <div class="swiper-button-next" slot="button-next"></div>
    </swiper>
    <!-- 视频预览dialog -->
    <IndexPlay :row="scheduleLab" ref="playRef" :is_who="3"></IndexPlay>
  </div>
</template>

<script>
export default {
  props: {
    postList: {
      type: Array,
    },
    srcList: {
      type: Array,
    },
    playerOptionsList: {
      type: Array,
    },
  },
  data() {
    return {
      swiperOption: {
        direction: "horizontal", //滑动方向，可设置水平(horizontal)或垂直(vertical)。
        // loop: true, // 设置为true 则开启loop模式
        // autoplay: 3000, // 自动切换时间
        slidesPerView: 5, // 设置slider容器能够同时显示的slides数量(carousel模式)。类型：number or auto
        centeredSlides: false, // 设定为true时，active slide会居中，而不是默认状态下的居左。
        spaceBetween: 18, // 在slide之间设置距离（单位px）。
        // loopAdditionaSlider: 0, // loop模式下会在slides前后复制若干个slide,，前后复制的个数不会大于原总个数。
        // 前进后退按钮
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        on: {
          //
        },
        // 特效
        // effect: "coverflow",
        // coverflowEffect: {
        //   rotate: 30,
        //   stretch: 5,
        //   depth: 0,
        //   modifier: 2,
        //   slideShadows: true,
        // },
      },
      defaultSrc: require("@/assets/images/video_backgroup.jpg"),
      scheduleLab: {},
    };
  },
  methods: {
    // 视频预览
    handleDetails(row) {
      this.scheduleLab = row;
      this.$nextTick(function () {
        this.$refs.playRef.handleUpdate();
      });
    },
  },
};
</script>
 
<style lang = "less" scoped>
.wall_style_swiper {
  position: relative;
  /deep/ .swiper {
    width: 1085px;
    position: static;
    .swiper-button-prev {
      left: 0;
    }
    .swiper-button-next {
      right: 0;
    }
    .video_c {
      .video-js {
        height: 144px;
      }
    }
  }
}
</style>